import { useCurrency } from '@ux/currency';
import { useBrandId } from '@ux/whitelabel';
import { Analytics } from 'core/ribbons/cta';
import { Behavior } from 'domain/constants/callToAction';
import { sendProductClicked, sendProductOnAddToBasket, sendPromotion } from 'application/actions/cta';
import { getProductData } from 'infrastructure/cta';
import { createRibbonName } from 'domain/transformers/ribbons';
import { useRibbon } from 'domain/selectors/ribbons';

interface Props {
  ribbonId?: string;
  behavior?: {
    type: Behavior;
    analytics?: Analytics;
    productId?: string | null;
    pricingTier?: {
      term?: number | null;
    };
  };
}

export default ({ ribbonId }: Props) => {
  const currency = useCurrency();
  const brandId = useBrandId();
  const ribbon = useRibbon(ribbonId);
  const list = createRibbonName(ribbon?.type, ribbon?.props?.name);

  return ({ behavior }: Props) => {
    const ctaType = behavior?.type;
    const type = behavior?.analytics?.type;
    const term = behavior?.pricingTier?.term;

    if (type === 'PRODUCT') {
      const productId = behavior?.analytics?.productId;
      sendProductClicked({
        productId,
        list,
        getProductData,
      });
    } else if (type === 'PROMOTION') {
      const promotion = behavior?.analytics?.promotion;
      sendPromotion({ promotion });
    } else if (ctaType === 'addToBasket') {
      const productId = behavior?.productId;
      sendProductOnAddToBasket({ productId, list, getProductData, currency, brandId, term });
    }
  };
};
